import React from "react";
import "./AboutHoldingSection.css";

function AboutHoldingSection() {
  return (
    <section>
      <h2 lang="ru" className="AboutHoldingSection-title">
        ЭР-Телеком – ведущая российская телекоммуникационная компания.
      </h2>
      <p className="AboutHoldingSection-text">
        АО «ЭР-Телеком Холдинг» предоставляет услуги широкополосного доступа в
        Интернет, телефонии, цифрового ТВ, доступа к сетям Wi-Fi, VPN, LoRaWAN,
        видеонаблюдения и комплексных решений на базе технологий промышленного
        Интернета вещей (IoT).
      </p>
    </section>
  );
}

export default AboutHoldingSection;



// WEBPACK FOOTER //
// ./src/components/AboutHoldingSection/index.js